<template>
  <div
    class="dynamic-tab"
    :class="{ 'dynamic-tab--disabled': disabled }"
  >
    <div
      v-for="(tab, index) in tabs"
      :key="index"
      class="dynamic-tab__title"
      :class="{ 'dynamic-tab__title--active': activeTab === index }"
      @click="handleClick(index)"
    >
      <span>{{ tab.title }}</span>
      <span
        v-if="tab.counter !== null && tab.counter !== undefined"
        class="dynamic-tab__counter"
        :class="{ 'dynamic-tab__counter--active': activeTab === index }"
      >
        {{ tab.counter }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DynamicTabs',
  props: {
    tabs: {
      type: Array,
      required: true,
      validator: (value) => {
        return value.every(tab => 'title' in tab);
      }
    },
    activeTab: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick(index) {
      if (!this.disabled && index !== this.activeTab) {
        this.$emit('update:activeTab', index);
      }
    }
  }
};
</script>

<style lang="scss">
.dynamic-tab {
  display: flex;
  margin-bottom: 25px;
  border-bottom: 1px solid #7f1a54;
  background-color: inherit;

  &--disabled {
    .dynamic-tab__title {
      cursor: progress;
    }
  }

  &__title {
    min-width: 155px;
    text-align: center;
    cursor: pointer;
    color: #979797;
    font-weight: bold;
    font-size: 10px;
    line-height: 12px;
    letter-spacing: 1.3px;
    text-transform: uppercase;
    padding: 12px 18px;
    position: relative;
    top: 1px;

    &--active {
      color: #7f1a54;
      border-top: 1px solid #7f1a54;
      border-left: 1px solid #7f1a54;
      border-right: 1px solid #7f1a54;
      border-top-right-radius: 4px;
      border-top-left-radius: 4px;
      background-color: #ebebeb;
      padding: 11px 17px 12px;
    }
  }

  &__counter {
    background-color: #c4c4c4;
    color: #fff;
    padding: 2px 9px;
    border-radius: 10px;
    margin-left: 3px;

    &--active {
      background-color: #7f1a54;
    }
  }
}
</style>
